import { render } from "./Circles.vue?vue&type=template&id=1517db1c&scoped=true"
import script from "./Circles.vue?vue&type=script&lang=js"
export * from "./Circles.vue?vue&type=script&lang=js"

import "./Circles.vue?vue&type=style&index=0&id=1517db1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1517db1c"]])

export default __exports__